import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
// import { ShopsLoaderModule } from './app/components/shops/shops.module';
// we are including the user module here as the user Modal breaks things currently
import { IonicModule } from '@ionic/angular';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { AnalyticsModule } from '@luggagehero/analytics/analytics.module';
import { LanguageProviders, Languages } from '@luggagehero/i18n';
import { provideBookingStack } from '@luggagehero/shared/booking-stack';
import { Config } from '@luggagehero/shared/environment';
// import { ShopsLoaderModule } from './app/components/shops/shops.module';
// we are including the user module here as the user Modal breaks things currently
import { AppSettingsOverrideIndicatorComponent } from '@luggagehero/shared-feature-app-settings-override-indicator';
import { LhCoreModule } from '@luggagehero/web/core';
import { UiModule } from '@luggagehero/web/features/ui';

import { AppComponent } from './app/components/app.component';
import { AppInitializer } from './app/components/app.initializer';
import { AppRouteReuseStrategy } from './app/components/app.route-reuse-strategy';
import { routes } from './app/components/app.routes';
import { UserLoaderModule } from './app/components/user/user.module';

// DISABLE lazy loading --- begin
// import { ShopsLoaderModule } from './app/components/shops/shops.module';                // Comment to enable lazy loading
// import { BookingsLoaderModule } from './app/components/bookings/bookings.module';             // Comment to enable lazy loading
// import { ShopManagerLoaderModule } from './app/components/shop-manager/shop-manager.module';  // Comment to enable lazy loading
// const featureModules = [ShopsLoaderModule, BookingsLoaderModule, ShopManagerLoaderModule];    // Comment to enable lazy loading
// DISABLE lazy loading --- end

// ENABLE lazy loading --- begin
const featureModules = []; // Comment to disable lazy loading
// ENABLE lazy loading --- end

const routerModule = RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' });

// Factory for supported languages
export function getSupportedLanguages() {
  return Config.supportedLanguages;
}

@NgModule({
  declarations: [AppComponent],
  exports: [
    // UiModule
  ],
  bootstrap: [AppComponent],
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  imports: [
    AppSettingsOverrideIndicatorComponent,
    LhCoreModule,
    IonicModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    routerModule,
    AnalyticsModule,
    UiModule,
    UserLoaderModule, // Remove this? (lazy load instead)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ...featureModules,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: Config.isProduction }),
  ],
  providers: [
    provideIonicAngular(),
    {
      provide: APP_BASE_HREF,
      useValue: '',
    },
    // default language providers
    LanguageProviders,
    // override with supported languages
    {
      provide: Languages,
      useFactory: getSupportedLanguages,
      deps: [],
    },
    {
      provide: RouteReuseStrategy,
      useClass: AppRouteReuseStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
    // Web-traveler's own initializer owns app-settings (appName 'web-traveler' +
    // DefaultAppSettings), pricing and translations, so provideBookingStack() below is
    // told not to bootstrap them. Registration order alone does not protect this: Angular
    // starts every initializer before awaiting any, and this one awaits windowService.init()
    // before its appSettings.init(), so the stack's init('landing', …) would claim the
    // first-caller-wins SharedAppSettingsService and the app would run on the landing
    // settings row (AM-4913: no PayPal option, so no payment option toggle at all).
    provideAppInitializer(() => {
      const initializerFn = ((appInitializer: AppInitializer) => {
        return () => appInitializer.init();
      })(inject(AppInitializer));
      return initializerFn();
    }),
    // Booking/payment service wiring shared with the landing app's booking wizard.
    provideBookingStack({ bootstrap: false }),
  ],
})
export class WebModule {}
